import { render } from "./Stock.vue?vue&type=template&id=539242fe"
import script from "./Stock.vue?vue&type=script&lang=js"
export * from "./Stock.vue?vue&type=script&lang=js"

import "./Stock.vue?vue&type=style&index=0&id=539242fe&lang=css"
import "./Stock.vue?vue&type=style&index=1&id=539242fe&lang=css"
script.render = render

export default script